export default __webpack_public_path__ + "static/media/Users.7db241c4.svg";